import React, {FC, ReactNode} from 'react';
import scss from './AnchorExternal.module.scss';

/**
 * See {@link AnchorHTMLAttributes}
 */

export interface AnchorExternalProps extends React.ComponentProps<'a'> {
    href: string;
    children?: ReactNode;
    download?: string;
    type?: string;
}

const AnchorExternal: FC<AnchorExternalProps> = ({children, className, href, download, type, ...rest}) => {
    return (
        <a
            href={new URL(href).toString()}
            {...rest}
            download={download}
            type={type}
            className={className ?? scss.link}
            target='_blank'
            rel='nofollow noreferrer noopener'
        >
            {children}
        </a>
    );
};

export default AnchorExternal;
